import React, {useState} from 'react';
import {Box, Typography, Button} from '@mui/material';
import {Plus} from 'react-feather';
import {ApiDetails} from "../../dummyData";

import ServiceProviderList from './ServiceProviderList';
import ServiceProviderDialog from './ServiceProviderDialog';

const ServiceProviderSection = ({
                                    providers,
                                    problemTypes,
                                    getLandlordId,
                                    showAlert,
                                    onProvidersUpdated
                                }) => {
    const [providerDialogOpen, setProviderDialogOpen] = useState(false);
    const [selectedProvider, setSelectedProvider] = useState(null);

    // Add or update service provider
    const handleSaveProvider = async (provider, isNew) => {
        console.log("PROVIDER DETAILS AFTER EDITING")
        console.log(provider);

        try {
            const landlordId = getLandlordId();
            if (!landlordId) return;

            const endpoint = isNew
                ? ApiDetails + "pegasus/visionary/tickets/api/service-providers/add"
                : ApiDetails + "pegasus/visionary/tickets/api/service-providers/update";

            const providerData = {
                ...provider,
                landlord_id: landlordId
            };

            const response = await fetch(endpoint, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "token": "8d5b2e7c-36f4-4b45-b79b-61fc60eb905d"
                },
                body: JSON.stringify(providerData)
            });

            if (response.status === 200) {
                showAlert(isNew ? "Service provider added successfully" : "Service provider updated successfully");
                onProvidersUpdated();
                setProviderDialogOpen(false);
                setSelectedProvider(null);
            } else {
                throw new Error(`Error: ${response.status}`);
            }
        } catch (error) {
            console.error("Error saving service provider:", error);
            showAlert(isNew ? "Failed to add service provider" : "Failed to update service provider", "error");
        }
    };

    // Delete service provider
    const handleDeleteProvider = async (providerId) => {
        try {
            const landlordId = getLandlordId();
            if (!landlordId) return;

            const response = await fetch(ApiDetails + "pegasus/visionary/tickets/api/service-providers/delete", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "token": "8d5b2e7c-36f4-4b45-b79b-61fc60eb905d"
                },
                body: JSON.stringify({
                    provider_id: providerId,
                    landlord_id: landlordId
                })
            });

            if (response.status === 200) {
                showAlert("Service provider deleted successfully");
                onProvidersUpdated();
            } else {
                throw new Error(`Error: ${response.status}`);
            }
        } catch (error) {
            console.error("Error deleting service provider:", error);
            showAlert("Failed to delete service provider", "error");
        }
    };

    return (
        <Box>
            <Box sx={{display: 'flex', justifyContent: 'space-between', mb: 2}}>
                <Typography variant="h6">Service Providers</Typography>
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<Plus size={16}/>}
                    onClick={() => {
                        setSelectedProvider(null);
                        setProviderDialogOpen(true);
                    }}
                    sx={{borderRadius: '8px', textTransform: 'none'}}
                >
                    Add Provider
                </Button>
            </Box>

            <ServiceProviderList
                providers={providers}
                onEdit={(provider) => {
                    setSelectedProvider(provider);
                    setProviderDialogOpen(true);
                }}
                onDelete={handleDeleteProvider}
                problemTypes={problemTypes}
            />

            <ServiceProviderDialog
                open={providerDialogOpen}
                provider={selectedProvider}
                onClose={() => {
                    setProviderDialogOpen(false);
                    setSelectedProvider(null);
                }}
                onSave={handleSaveProvider}
                problemTypes={problemTypes}
            />
        </Box>
    );
};

export default ServiceProviderSection;